import type {MaterialsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/MaterialsNetwork';
import type {GeoObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import type {EventsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/EventsNetwork';
import type {PerspectiveCameraObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/PerspectiveCamera';
import type {RootManagerNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import type {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	function create_geo1(parentNode: RootManagerNode) {
		var geo1 = parentNode.createNode('geo');
		geo1.setName('geo1');
		function create_MAT(geo1: GeoObjNode) {
			var MAT = geo1.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_meshToon1(MAT: MaterialsNetworkSopNode) {
				var meshToon1 = MAT.createNode('meshToon');
				meshToon1.setName('meshToon1');
				meshToon1.uiData.setPosition(0, -50);
				meshToon1.p.color.set([0.8823529411764706, 0.5058823529411764, 0.2549019607843137]);
				meshToon1.params.postCreateSpareParams();
				meshToon1.params.runOnSceneLoadHooks();
				return meshToon1;
			}
			create_meshToon1(MAT);
			MAT.uiData.setPosition(-350, 200);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_fileGLTF1(geo1: GeoObjNode) {
			var fileGLTF1 = geo1.createNode('fileGLTF');
			fileGLTF1.setName('fileGLTF1');
			fileGLTF1.uiData.setPosition(-150, -50);
			fileGLTF1.p.url.set(
				'https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master/models/resources/quaternius/animals/Horse.gltf'
			);
			fileGLTF1.params.postCreateSpareParams();
			fileGLTF1.params.runOnSceneLoadHooks();
			return fileGLTF1;
		}
		function create_material1(geo1: GeoObjNode) {
			var material1 = geo1.createNode('material');
			material1.setName('material1');
			material1.uiData.setPosition(-150, 200);
			material1.flags.display.set(true);
			material1.p.material.set('../MAT/meshToon1');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_transform1(geo1: GeoObjNode) {
			var transform1 = geo1.createNode('transform');
			transform1.setName('transform1');
			transform1.uiData.setPosition(-150, 50);
			transform1.p.applyOn.set(1);
			transform1.p.scale.set(0.25);
			transform1.params.postCreateSpareParams();
			transform1.params.runOnSceneLoadHooks();
			return transform1;
		}
		create_MAT(geo1);
		var fileGLTF1 = create_fileGLTF1(geo1);
		var material1 = create_material1(geo1);
		var transform1 = create_transform1(geo1);
		material1.setInput(0, transform1);
		transform1.setInput(0, fileGLTF1);
		geo1.uiData.setPosition(-50, -150);
		geo1.flags.display.set(true);
		geo1.params.postCreateSpareParams();
		geo1.params.runOnSceneLoadHooks();
		return geo1;
	}
	function create_grid(parentNode: RootManagerNode) {
		var grid = parentNode.createNode('geo');
		grid.setName('grid');
		function create_planeHelper1(grid: GeoObjNode) {
			var planeHelper1 = grid.createNode('planeHelper');
			planeHelper1.setName('planeHelper1');
			planeHelper1.uiData.setPosition(0, 0);
			planeHelper1.flags.display.set(true);
			planeHelper1.params.postCreateSpareParams();
			planeHelper1.params.runOnSceneLoadHooks();
			return planeHelper1;
		}
		create_planeHelper1(grid);
		grid.uiData.setPosition(-50, -250);
		grid.flags.display.set(true);
		grid.params.postCreateSpareParams();
		grid.params.runOnSceneLoadHooks();
		return grid;
	}
	function create_perspectiveCamera1(parentNode: RootManagerNode) {
		var perspectiveCamera1 = parentNode.createNode('perspectiveCamera');
		perspectiveCamera1.setName('perspectiveCamera1');
		function create_events1(perspectiveCamera1: PerspectiveCameraObjNode) {
			var events1 = perspectiveCamera1.createNode('eventsNetwork');
			events1.setName('events1');
			function create_cameraOrbitControls1(events1: EventsNetworkSopNode) {
				var cameraOrbitControls1 = events1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(150, 50);
				cameraOrbitControls1.p.target.set([0.09038083430380983, 0.6798456202391073, 0.28455932605119966]);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(events1);
			events1.uiData.setPosition(-200, 50);
			events1.params.postCreateSpareParams();
			events1.params.runOnSceneLoadHooks();
			return events1;
		}
		create_events1(perspectiveCamera1);
		perspectiveCamera1.uiData.setPosition(-200, 100);
		perspectiveCamera1.flags.display.set(true);
		perspectiveCamera1.p.t.set([1.4983708220318666, 0.9304216098655744, 1.6569575758310338]);
		perspectiveCamera1.p.r.set([-10.347235096885514, 45.26375735149414, 7.3899140981050175]);
		perspectiveCamera1.p.s.set([0.9999999999999999, 0.9999999999999999, 0.9999999999999999]);
		perspectiveCamera1.p.controls.set('./events1/cameraOrbitControls1');
		perspectiveCamera1.params.postCreateSpareParams();
		perspectiveCamera1.params.runOnSceneLoadHooks();
		return perspectiveCamera1;
	}
	function create_spotLight1(parentNode: RootManagerNode) {
		var spotLight1 = parentNode.createNode('spotLight');
		spotLight1.setName('spotLight1');
		spotLight1.uiData.setPosition(200, 200);
		spotLight1.flags.display.set(true);
		spotLight1.p.showHelper.set(true);
		spotLight1.params.postCreateSpareParams();
		spotLight1.params.runOnSceneLoadHooks();
		return spotLight1;
	}
	function create_polarTransform1(parentNode: RootManagerNode) {
		var polarTransform1 = parentNode.createNode('polarTransform');
		polarTransform1.setName('polarTransform1');
		polarTransform1.uiData.setPosition(200, 50);
		polarTransform1.flags.display.set(false);
		polarTransform1.p.longitude.set(-309.6);
		polarTransform1.p.latitude.set(32.4);
		polarTransform1.p.depth.set(2.2);
		polarTransform1.params.postCreateSpareParams();
		polarTransform1.params.runOnSceneLoadHooks();
		return polarTransform1;
	}
	var geo1 = create_geo1(root);
	create_grid(root);
	var perspectiveCamera1 = create_perspectiveCamera1(root);
	var spotLight1 = create_spotLight1(root);
	var polarTransform1 = create_polarTransform1(root);
	spotLight1.setInput(0, polarTransform1);
	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [geo1.nodesByType('material')[0]],
		autoLayout: false,
	};
}
// export const matMeshToon = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/mat/meshToon`,
// 		createData,
// 		relatedNodes: [MeshToonMatNode],
// 	}),
// ];
